import axiosInstance from '../app/axios';
import DefaultPaginationProps from '../propInterfaces/defaultPaginationProps';

export const getProviderList = async () => {
  const result = await axiosInstance.get("providers");
  return result.data.data;
};

export const getAvailableProviderList = async (
  serviceTypeId: number | null | undefined,
  search?: string | null,
  orderBy?: string | null,
  order?: "ASC" | "DESC" | null,
) => {
  let url = `providers/${serviceTypeId}`;
  const params = new URLSearchParams();
  if (search) params.append("search", search);
  if (orderBy) params.append("orderBy", orderBy);
  if (order) params.append("order", order);

  const queryString = params.toString();
  if (queryString) url += `?${queryString}`;

  const result = await axiosInstance.get(url);

  return result.data;
};

export const getProviderPaginatedDocuments = async ({
  page,
  take,
  search: searchText,
  startDate,
  endDate,
}: DefaultPaginationProps) => {
  const result = await axiosInstance.post(
    `admin/trip/report/provider/document?page=${page}&take=${take}`,
    {
      search: searchText,
      startDate,
      endDate,
    },
  );

  return result.data;
};

export const getProviderEmails = async ({
  startDate,
  endDate,
  type,
  countryId
}: DefaultPaginationProps) => {
  const result = await axiosInstance.post("providers/emails/search/bydate", {
    startDate,
    endDate,
    type,
    countryId,
  });
  return result.data;
};

export const getProviderExcel = async ({
  search,
  startDate,
  endDate,
}: DefaultPaginationProps) => {
  const result = await axiosInstance.post(
    "user-request/report/statement/excel/provider",
    {
      search,
      startDate,
      endDate,
    },
  );

  return result.data;
};
